import type { SystemLanguage } from "./types";

const systemLanguages: SystemLanguage[] = [
  {
    id: "tr",
    flag: "TR",
    title: "Türkçe",
    testid: "turkish"
  },
  {
    id: "en",
    flag: "GB",
    title: "English",
    testid: "english"
  },
  {
    id: "uk",
    flag: "UA",
    title: "Український",
    testid: "ukrainian"
  },
  {
    id: "ru",
    flag: "RU",
    title: "Pyccкий",
    testid: "russian"
  },
  {
    id: "de",
    flag: "DE",
    title: "Deutsch",
    testid: "german"
  },
  {
    id: "es",
    flag: "ES",
    title: "Español",
    testid: "spanish"
  },
  {
    id: "fr",
    flag: "FR",
    title: "Français",
    testid: "french"
  },
  {
    id: "it",
    flag: "IT",
    title: "Italiano",
    testid: "italian"
  },
  {
    id: "az",
    flag: "AZ",
    title: "Azərbaycan",
    testid: "azerbaijani"
  },
  {
    id: "nl",
    flag: "NL",
    title: "Nederland",
    testid: "nederland"
  },
  {
    id: "lb",
    flag: "LB",
    title: "Lëtzebuerg",
    testid: "lëtzebuerg"
  },
  {
    id: "nb-NO",
    flag: "NO",
    title: "Norwegian",
    testid: "norwegian"
  }
];

export { systemLanguages };
